import { fetchTerminalStatus } from './rest'

export async function checkMaintenanceMode(port, terminal, username) {
  try {
    const status = await getTerminalStatus(port, terminal, username)

    console.info('checkMaintenanceMode terminalStatus = ' + status)

    if (status === 'MAINTENANCE') {
      throw new Error(
        'Cannot login: the application is currently in maintenance mode. ' +
          'This should take less than 15 minutes. Please try again later.'
      )
    }
  } catch (err) {
    console.error(err)
  }
}

export async function getTerminalStatus(port, terminal, username) {
  try {
    const terminalStatuses = await fetchTerminalStatus(port, terminal, username)

    const terminalStatus = terminalStatuses.find(terminalStatus => {
      return terminalStatus.port === port && terminalStatus.terminal === terminal
    })

    return terminalStatus.status
  } catch (err) {
    console.error(err)
    return null
  }
}
